{
  "next": "Далее",
  "previous": "Назад"
}
